import { useSelector } from 'react-redux';
import type { AppConfigState } from './configSlice';

type RootWithConfig = { config: AppConfigState };

/** Read the tenant config + helpers to apply terminology and gate screens. */
export function useConfig() {
  const config = useSelector((s: RootWithConfig) => s.config);
  return {
    ...config,
    /** Terminology override for [key] (e.g. 'item' → 'Product'), else [fallback]. */
    term: (key: string, fallback: string) => config.terminology[key] ?? fallback,
    /** Whether a vertical-specific screen key is enabled for this industry. */
    hasScreen: (key: string) => config.enabledScreens.includes(key)
  };
}
